import { Components } from '@mui/material'
import { outlinedInputClasses } from '@mui/material/OutlinedInput'
import { selectClasses } from '@mui/material/Select'

const MuiSelect: Components['MuiSelect'] = {
  styleOverrides: {
    icon: {
      right: 8,
      top: 'calc(50% - 8px)',
    },
    nativeInput: {
      boxSizing: 'border-box',
    },
    outlined: {
      [`.${outlinedInputClasses.adornedEnd} &`]: {
        borderBottomRightRadius: 0,
        borderTopRightRadius: 0,
        paddingRight: 24,
      },
      [`.${outlinedInputClasses.adornedEnd} & ~ .${selectClasses.icon}`]: {
        marginLeft: -16,
        position: 'static',
      },
    },
  },
}

export default MuiSelect
